// src/features/executive/account/usedStyle.tsx
import { Box, styled } from '@mui/material'

export const TabRoot = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),  // larger gap between sections vs within sections
}))

// Section = header + one or more rows.
export const Section = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}))

// 3-col hero row for balance/advance/wallet KPI tiles.
export const HeroRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr',
  alignItems: 'stretch',
  [theme.breakpoints.up('sm')]: { gridTemplateColumns: 'repeat(2, 1fr)' },
  [theme.breakpoints.up('md')]: { gridTemplateColumns: 'repeat(3, 1fr)' },
}))

// 2/1 split row (kept for legacy callers).
export const DetailRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr',
  alignItems: 'stretch',
  [theme.breakpoints.up('md')]: { gridTemplateColumns: '2fr 1fr' },
}))

// 2-col category row — treatment revenue + expense category.
export const CategoryRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: '1fr',
  alignItems: 'stretch',
  [theme.breakpoints.up('md')]: { gridTemplateColumns: 'repeat(2, 1fr)' },
}))
